// extracted by mini-css-extract-plugin
module.exports = {"Icon":"EditMenuButton_Icon__N2Eug"};